let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3e44O")).then(() => parcelRequire('5MP4h'));